import { ITableCol } from "@data/interfaces/itable.interface";
import { CONVERSION_STATUS_COLOR_ENUM, CONVERSION_STATUS_ENUM, CUSTOMER_STATUS_COLOR_ENUM, CUSTOMER_STATUS_ENUM } from "@modules/private/customer/data/enum/customer.enum";

export const CUSTOMER_STATUS_OPTIONS = [
  { value: 'Active', label: 'Activo' },
  { value: 'Inactive', label: 'Baja' }
]

export const CONVERSION_STATUS_OPTIONS = [
  { value: 'in_funnel', label: 'En funnel' },
  { value: 'in_origination', label: 'En originación' },
  { value: 'won', label: 'Ganado' },
  { value: 'lost', label: 'Perdido' }
]

//* Badge de actividad de arrendamiento en la pestaña Clientes. `hasActiveLease` es
//* boolean; las claves van como string 'true'/'false' porque `selectEnum` resuelve
//* con `enum[value]` (JS coacciona la clave a string). Un cliente `won` que liquidó
//* su lease permanece Cliente pero se marca "Sin arrendamiento activo".
export const LEASE_ACTIVITY_ENUM: Record<string, string> = {
  true: 'Activo',
  false: 'Sin arrendamiento activo'
}
export const LEASE_ACTIVITY_COLOR_ENUM: Record<string, string> = {
  true: 'success',
  false: 'warning'
}

export const CUSTOMER_COLUMNS: ITableCol[] = [
  { type: 'text', field: '_id', header: 'id del Cliente', showFilter: false, dataType: 'link', linkField: '_id', rootLink: 'customer' },
  { type: 'text', field: 'name', header: 'Nombre', showFilter: true },
  { type: 'text', field: 'rfc', header: 'RFC', showFilter: true },
  { type: 'text', field: 'entity', header: 'Tipo de persona', showFilter: true },
  { type: 'text', field: 'industrySector', header: 'Sector', showFilter: true },
  { type: 'text', field: 'industrySubsector', header: 'SubSector', showFilter: true },
  { type: 'number', field: 'anualIncome', header: 'Ventas / Ingresos', showFilter: true, dataType: 'currency' },
  { type: 'number', field: 'employees', header: 'Empleados', showFilter: true },
  { type: 'text', field: 'phone', header: 'Teléfono', showFilter: true },
  { type: 'text', field: 'email', header: 'Email', showFilter: true },
  { type: 'enum', field: 'status', header: 'Estatus', showFilter: true, dataType: 'enum', enum: CUSTOMER_STATUS_ENUM, enumColor: CUSTOMER_STATUS_COLOR_ENUM, options: CUSTOMER_STATUS_OPTIONS },
]

//* Pestaña Clientes (conversionStatus='won': ya nos compró alguna vez): identidad +
//* contacto + estatus + badge de si tiene arrendamiento activo AHORA. Un cliente que
//* liquidó su lease sigue siendo Cliente, marcado "Sin arrendamiento activo".
export const CLIENTES_COLUMNS: ITableCol[] = [
  { type: 'text', field: 'name', header: 'Nombre', showFilter: true, dataType: 'link', linkField: '_id', rootLink: 'customer' },
  { type: 'text', field: 'rfc', header: 'RFC', showFilter: true },
  { type: 'text', field: 'entity', header: 'Tipo de persona', showFilter: true },
  { type: 'enum', field: 'hasActiveLease', header: 'Arrendamiento', showFilter: false, dataType: 'enum', enum: LEASE_ACTIVITY_ENUM, enumColor: LEASE_ACTIVITY_COLOR_ENUM },
  { type: 'text', field: 'phone', header: 'Teléfono', showFilter: true },
  { type: 'text', field: 'email', header: 'Email', showFilter: true },
  { type: 'enum', field: 'status', header: 'Estatus', showFilter: true, dataType: 'enum', enum: CUSTOMER_STATUS_ENUM, enumColor: CUSTOMER_STATUS_COLOR_ENUM, options: CUSTOMER_STATUS_OPTIONS },
]

//* Pestaña Prospectos (sin lease activo): añade estado del funnel + canal de origen.
export const PROSPECTOS_COLUMNS: ITableCol[] = [
  { type: 'text', field: 'name', header: 'Nombre', showFilter: true, dataType: 'link', linkField: '_id', rootLink: 'customer' },
  { type: 'text', field: 'rfc', header: 'RFC', showFilter: true },
  { type: 'text', field: 'entity', header: 'Tipo de persona', showFilter: true },
  { type: 'enum', field: 'conversionStatus', header: 'Estado funnel', showFilter: true, dataType: 'enum', enum: CONVERSION_STATUS_ENUM, enumColor: CONVERSION_STATUS_COLOR_ENUM, options: CONVERSION_STATUS_OPTIONS },
  { type: 'text', field: 'currentChannelKey', header: 'Canal', showFilter: true, dataType: 'channel' },
  { type: 'text', field: 'phone', header: 'Teléfono', showFilter: true },
  { type: 'text', field: 'email', header: 'Email', showFilter: true },
]

export const CUSTOMER_ACTIONS = [
  {
    title: 'Editar',
    icon: 'fa-solid fa-edit',
    action: 'EDIT',
    color: 'primary',
    permission: ['clients', 'update'] as [string, string]
  }
];

